import { baseMutations, baseActions } from '../functions'

export default {
  namespaced: true,
  state: {
    // Info
    items: [],
    title: 'Empresas',
    name: 'Empresas',
    loading: true,

    // Menu
    menu: {
      title: 'Empresas',
      icon: { key: 'empresas', custom: true }
    },

    // Routes - Components actions
    actions: {
      // Main Action
      component: 'Cards.Empresas', // Alterado para 'Cards.Empresas'
      props: { title: 'Empresas com acesso a plataforma', module: 'users', modelKey: 'profile' },
      children: [
        {
          key: 'add',
          scope: 'Title',
          event: 'link',
          options: { label: 'Nova Empresa', icon: 'add' },
          component: 'Form',
          props: { title: 'Cadastrar nova empresa', module: 'users', formKey: 'save', requests: 'add' }
        },
        {
          key: 'edit',
          scope: 'Buttons',
          options: { theme: 'warning' },
          event: 'link',
          params: ['id'],
          component: 'Form',
          props: route => ({ itemId: route.params.id, title: 'Editar empresa', module: 'users', formKey: 'save', requests: 'edit' })
        },
        {
          key: 'delete',
          scope: 'Buttons',
          options: { theme: 'danger' },
          event: 'modal',
          component: 'Delete',
          props: item => ({ item: item, module: 'users' })
        }
      ]
    },

    // API Get index
    get: {
      urn: 'empresas/index', // Rota para buscar empresas
      response: 'empresas' // Resposta esperada
    },

    // API routes
    requests: {
      add: {
        title: 'Cadastrar nova Empresa',
        success: 'Empresa cadastrada com sucesso',
        urn: 'auth/create',
        response: 'empresa',
        method: 'post',
        dispatch: 'add'
      },
      edit: {
        title: 'Editar Empresa',
        success: 'Empresa editada com sucesso',
        urn: 'auth/edit',
        response: 'empresa',
        method: 'post',
        dispatch: 'edit'
      },
      delete: {
        title: 'Deletar Empresa',
        success: 'Empresa deletada com sucesso',
        urn: 'auth/delete?empresa_id=:id',
        method: 'delete',
        dispatch: 'delete'
      }
    },

    // Models
    models: {
      profile: [
        { key: 'name', label: 'Nome', slot: 'Nome' }
      ]
    },

    // Forms
    forms: {
      save: [
        { key: 'empresa_id', type: 'hidden', from: 'item', value: 'id' },
        { key: 'name', label: 'Nome', type: 'text', col: 6 },
        { key: 'email', label: 'Email', type: 'text', col: 6 },
        { key: 'document', label: 'Documento', type: 'text', col: 3 },
        { key: 'telephone', label: 'Telefone', type: 'text', col: 3 }
      ]
    }

  },
  mutations: Object.assign({}, baseMutations, {
    // ...
  }),
  actions: Object.assign({}, baseActions, {
    // ...
    // ...
  })
}
